import { Routes, Route, useParams } from 'react-router-dom';
import { useWorkerProject } from './hooks/useWorkerProject';
import { WorkerHome } from './pages/WorkerHome';
import { WorkerDocuments } from './pages/WorkerDocuments';
import { WorkerCalculator } from './pages/WorkerCalculator';
import { WorkerError } from './pages/WorkerError';
import { LoadingPage } from './components/ui';

function WorkerRoutes() {
  const { token } = useParams<{ token: string }>();
  const { project, loading, error, refetch } = useWorkerProject(token || '');

  if (loading) {
    return <LoadingPage message="Vérification de l'accès..." />;
  }

  if (error || !project) {
    return (
      <WorkerError
        error={{
          type: 'invalid_token',
          message: error || 'Token invalide ou expiré'
        }}
        onRetry={refetch}
      />
    );
  }

  return (
    <Routes>
      <Route 
        path="/" 
        element={<WorkerHome project={project} token={token!} />} 
      />
      <Route 
        path="/documents" 
        element={<WorkerDocuments project={project} token={token!} />} 
      />
      <Route 
        path="/calculator" 
        element={<WorkerCalculator project={project} token={token!} />} 
      />
    </Routes>
  );
}

export function WorkerApp() {
  return (
    <div className="worker-app">
      <Routes>
        <Route path="/:token/*" element={<WorkerRoutes />} />
      </Routes>
    </div>
  );
}